module.exports = {
	"header": "Spotin Releases Self-service Portal for Sellers and Publishers to Supercharge Content Commerce",
	"date": "2023/09/21",
	"imgSrc": "Portal_release.png",
	"imgAlt": "Spotin Releases Self-service Portal for Sellers and Publishers to Supercharge Content Commerce",
	"ingress": "Spotin - the leading content commerce solutions provider - announces the Spotin Portal. The first self-service tool for adding commerce to any site or content. With the Portal Sellers and Publishers can establish partnerships from a catalogue of Publishers and Sellers (brands/retailers), agree on CPO commissions, and collaborate on site-specific campaign prices.",
	"sections": [
		{
			"paragraphs": [
				"The Spotin Portal is also giving Sellers and Publishers detailed sales analytics from a holistic view of the sales funnel: from discovery to a completed sale. All data is collected without the use of 3rd-party cookies and infringement of end-customer privacy. Data is presented in a user-tailored dashboard to visualize the most relevant data to Sellers and Publishers so that both stakeholders get relevant feedback and work actively with driving and evaluating sales performance across sites and campaigns.",
				"The Spotin Portal also offers capabilities such as product and order management. Features to allow Sellers to sell their products via Spotin without a product or order integration will be rolled out in a coming version.",
				"With the Portal Publishers and Sellers will be able to sign up and get started with Spotin and content commerce with a simple self-service process. For Sellers the Portal is also the hub to manage their full product catalogue synced with Spotin, and order integration towards their e-commerce platform."
			],
			"quote": {
				"text": "<p>“With the Portal Publishers and Sellers will be able to sign up and get started with Spotin and content commerce with a simple self-service process. For Sellers the Portal is also the hub to manage their full product catalogue synced with Spotin, and order integration towards their e-commerce platform.</p><p>Spotin Portal is a game-changer that simplifies the complexity of adding commerce to content. It's the one-stop solution for increasing conversion and sales reach, fostering collaborations, and maximizing revenue.”</p>",
				"author": "Kristoffer Karlsson",
				"title": "CEO, Spotin"
			}
		},
		{
			"paragraphs": [
				"Spotin Portal is available in the Beta now for Spotin users.",
				"For more information and to learn more about Spotin Portal, visit <a href='https://www.spotin.com/portal' style='text-decoration: underline;'>spotin.com/portal</a>."
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./pages/news/16/article.json
// module id = 14
// module chunks = 0